import { useSearchParams } from 'next/navigation';

export const createHref = (path: string, queryString: string = '') => {
  return queryString ? `${path}?${queryString}` : path;
};

export const useCreateHref = () => {
  const searchParams = useSearchParams();

  return (path: string) => {
    const params = new URLSearchParams(searchParams.toString());
    const queryString = params.toString();
    return queryString ? `${path}?${queryString}` : path;
  };
};
